module.exports = __webpack_public_path__ + "img/天力冲锋衣.944377a8.png";